module.exports = __webpack_public_path__ + "assets/insertpoint.6926a607.svg";